export default "__VITE_ASSET__BTqq1M_6__"